import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import transporterService from "../../services/transporterService";

export const fetchTransporter=createAsyncThunk(
    "transporter/fetch",
    async()=>{

        return await transporterService.getTransporter();

    }
);

export const removeTransporter=createAsyncThunk(
    "transporter/delete",
    async(id)=>{

        await transporterService.deleteTransporter(id);

        return id;

    }
);

export const addTransporter = createAsyncThunk(
    "transporter/add",
    async (formData, thunkAPI) => {
        try {
            return await transporterService.addTransporter(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const transporterSlice=createSlice({

    name:"transporter",

    initialState:{
        transporter:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchTransporter.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchTransporter.fulfilled,(state,action)=>{
    state.loading=false;
    state.transporter=action.payload;
})

.addCase(fetchTransporter.rejected,(state)=>{
    state.loading=false;
})

.addCase(addTransporter.fulfilled,(state,action)=>{

    state.transporter.unshift(action.payload);

})

.addCase(removeTransporter.fulfilled,(state,action)=>{

    state.transporter=
    state.transporter.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default transporterSlice.reducer;